// App : TokenComponent
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import UnauthenticatedAppRoot from './routes/UnauthenticatedAppRoot'
import { CircularProgress } from '@mui/material'
import AppRoot from './routes/AppRoot'
import { useSelector } from 'react-redux'
import { RootState } from './store'

import { OneViewFull } from './img/Icons'

const _loading = (
  <div className={'loadingDiv '}>
    <div className={'authenticateDiv'}>
      <div className={'headerTitle'}>
        <OneViewFull style={{ width: '100%' }} />
      </div>

      <div>Authenticating...</div>

      <div style={{ padding: 20 }}>
        <CircularProgress style={{ color: 'rgb(0, 120, 212)' }} />
      </div>
    </div>
  </div>
)

const TokenComponent = () => {
  const token = useSelector((state: RootState) => state.token.token)

  // console.log('token render');
  return (
    <>
      <AuthenticatedTemplate>{token ? <AppRoot data-file="TokenComponent" /> : _loading}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnauthenticatedAppRoot />
      </UnauthenticatedTemplate>
    </>
  )
}

export default TokenComponent
